import styles from './LoginFooter.module.css';

export function LoginFooter() {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <span>© 2025 Happy Days Tech</span>

        <a
          href="mailto:ayuda@delt.ai"
          className={styles.link && styles.fullText}
        >
          Contáctanos con un correo a <b>ayuda@delt.ai</b>
        </a>

        <a
          href="mailto:ayuda@delt.ai"
          className={styles.link && styles.mobileOnly}
        >
          <b>ayuda@delt.ai</b>
        </a>

        <a
          href="/help"
          className={styles.link}
        >
          Centro de Ayuda
        </a>
      </div>

      <button
        className={styles.chatButton}
        aria-label="Ayuda"
        onClick={() => {
          // Open chat / soport
        }}
      >
        💬
      </button>
    </footer>
  );
}
